import React from 'react';
import PropTypes from 'prop-types';
import icons from '../../../helpers/Icons';

const LogoUpload = ({
  name,
  logoSrc,
  onFileSelect,
  onFileRemove,
  acceptedTypes,
}) => {
  return (
    <div className="logo__preview">
      { logoSrc && <img alt="user avatar" src={logoSrc} /> }
      { !logoSrc && <span className="logo__preview__placeholder">Logo</span> }
      <input
        id="file-upload-input"
        name={name}
        type="file"
        accept={acceptedTypes.join(', ')}
        className="upload-input"
        onChange={onFileSelect}
      />
      <div className="logo__preview__options">
        <label htmlFor="file-upload-input" className="file-icon">
          {icons('upload')}
        </label>
        <span className="file-icon" onClick={onFileRemove}>
          {icons('delete')}
        </span>
      </div>
      <style jsx="true">{`
        .upload-input {
          z-index: -1;
          width: 0.1px;
          height: 0.1px;
          position: absolute;
        }
        .file-icon {
          cursor: pointer;
          width: auto;
        }
        .logo__preview {
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          height: 180px;
          border: 1px solid #eae8eb;
          border-radius: 5px;
          background-color: #808080;
          margin-bottom: 20px;
        }
        .logo__preview__placeholder {
          position: absolute;
          font-size: 44px;
          color: #c2c2c2;
        }
        .logo__preview:hover > .logo__preview__options {
          opacity: .6;
        }
        .logo__preview img {
          height: 100%;
        }
        .logo__preview__options {
          display: flex;
          justify-content: space-evenly;
          transition: all .3s;
          position: absolute;
          width: 100%;
          height: 30px;
          background-color: #000;
          opacity: 0;
          bottom: 0;
          padding-top: 2px;
        }
      `}</style>
    </div>
  );
};

LogoUpload.propTypes = {
  name: PropTypes.string.isRequired,
  logoSrc: PropTypes.string.isRequired,
  onFileSelect: PropTypes.func.isRequired,
  onFileRemove: PropTypes.func.isRequired,
  acceptedTypes: PropTypes.arrayOf(PropTypes.string),
};

LogoUpload.defaultProps = {
  acceptedTypes: [],
};

export default LogoUpload;
